module.exports = __webpack_public_path__ + "img/Floyd Wilson, Irving Peddrew and Charles Yates .1d543805.jpg";